module.exports = __webpack_public_path__ + "static/img/4480_phase_function_Paper_Points.36e1373.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4480_phase_function_Paper_Points.png
// module id = qHbL
// module chunks = 0